// extracted by mini-css-extract-plugin
module.exports = {"modalSave":"ModalSave_modalSave___ItzM","slideInFromTop":"ModalSave_slideInFromTop__o9jKw","saveIcon":"ModalSave_saveIcon__Awqq1"};